export const componentName = 'B2bConfirm';
